import type { StyleRule } from '@archipro-design/aria';
import { checkboxClassName } from '@archipro-design/aria';
import { drawerSlotClassNames } from '@archipro-design/aria';
import { inputClassName } from '@archipro-design/aria';
import { textInputSlotClassNames } from '@archipro-design/aria';
import { inputSlotClassNames } from '@archipro-design/aria';
import { textInputClassName } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import {
    labelClassName,
    captionClassName,
    filterContentLayoutSlotClassNames,
} from '@archipro-design/aria';
import { buttonClassName } from '@archipro-design/aria';
import { dropdownSlotClassNames } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';
import { accordionSlotClassNames } from '@fluentui/react-northstar';

export const FilterDropdownStyle = {
    marginBottom: pxToRem(2),
    [`& .${textInputSlotClassNames.primaryContent}`]: {
        [`& .${inputClassName}`]: {
            minHeight: 'unset',
            letterSpacing: 0,
        },
        [`& .${dropdownSlotClassNames.container}`]: {
            border: 'none',
        },
        [`& .${inputSlotClassNames.icon}`]: {
            minHeight: 'unset',
            height: pxToRem(36),
            marginTop: pxToRem(4),
            marginBottom: pxToRem(4),
        },
        [`& .${dropdownSlotClassNames.selectedItems}`]: {
            height: pxToRem(47),
        },
        [`& .${dropdownSlotClassNames.searchInput}`]: {
            padding: pxToRem(8),
            '& .ui-dropdown__items-list': {
                height: 0,
            },

            [`& input`]: {
                fontSize: pxToRem(18),
                letterSpacing: 0,
            },
        },
    },

    [`& .${inputSlotClassNames.icon}`]: {
        [`& .${svgIconClassName}`]: {
            height: pxToRem(24),
            marginTop: pxToRem(8),
            marginBottom: pxToRem(2),
        },
    },
};

export const DialogContentWrapper: StyleRule = ({ theme }) => ({
    '& *': {
        '-webkit-tap-highlight-color': 'transparent',
    },
    [`& .${captionClassName}`]: {
        color: theme.siteVariables.colors.charcoal['250'],
    },
    [`& .${filterContentLayoutSlotClassNames.headerAction}`]: {
        [`& .${buttonClassName}:hover`]: {
            textDecoration: 'none',
        },
        [`& .${labelClassName}`]: {
            color: theme.siteVariables.colors.charcoal['250'],
        },
    },
    [`& .${filterContentLayoutSlotClassNames.closeBtn}`]: {
        [`& .${svgIconClassName}`]: {
            '& svg': {
                fill: theme.siteVariables.colors.charcoal['250'],
            },
        },
    },
    [`& .${filterContentLayoutSlotClassNames.footer}`]: {
        [`& .${labelClassName}`]: {
            textTransform: 'uppercase',
        },
    },
    [`& .${filterContentLayoutSlotClassNames.content}`]: {
        display: 'block',
    },
});

export const ApplyButton: StyleRule = ({ theme }) => {
    return {
        [`& .${labelClassName}`]: {
            color: `${theme.siteVariables.colors.white['100']} !important`,
        },
    };
};

export const FilterDrawer: StyleRule = ({ theme }) => ({
    ':focus-within': {
        [`& .${textInputClassName}`]: {
            [`& .${dropdownSlotClassNames.triggerButton}`]: {
                backgroundColor: 'transparent',
            },
        },
    },
    height: '100%',
    [`& .${dropdownSlotClassNames.selectedItems}`]: {
        overflow: 'hidden',
    },

    [`& .${drawerSlotClassNames.content} .filterContainer`]: {
        height: '100%',
        backgroundColor: theme.siteVariables.colors.white['100A'],
        width: pxToRem(498),

        [`& .${captionClassName}`]: {
            color: theme.siteVariables.colors.charcoal['000'],
        },

        [`& .${accordionSlotClassNames.title}`]: {
            color: theme.siteVariables.colors.charcoal['000'],
        },
        [`& .${labelClassName}`]: {
            color: theme.siteVariables.colors.charcoal['000'],
        },

        [`& > div`]: {
            paddingLeft: pxToRem(50),
            paddingRight: pxToRem(50),
            width: 'auto',
        },

        [`& .${checkboxClassName}`]: {
            [`& .${labelClassName}`]: {
                fontSize: theme.siteVariables.fontSizes['label02'],
            },
        },
    },
});

export const FilterMonth: StyleRule<{ month: number | null }> = ({
    theme,
    month,
}) => ({
    ...FilterDropdownStyle,
    ...(month === null
        ? {
              [`& .${dropdownSlotClassNames.clearIndicator}`]: {
                  display: 'none',
              },
          }
        : {
              [`& .${inputSlotClassNames.input}`]: {
                  [`& .${dropdownSlotClassNames.triggerButton}`]: {
                      color: theme.siteVariables.colors.charcoal['250'],
                  },
              },
          }),
});

export const FilterYear: StyleRule<{ year: number | null }> = ({
    theme,
    year,
}) => ({
    ...FilterDropdownStyle,
    ...(year !== null && {
        [`& .${inputSlotClassNames.input}`]: {
            [`& .${dropdownSlotClassNames.triggerButton}`]: {
                color: theme.siteVariables.colors.charcoal['250'],
            },
        },
    }),
});

export const PublishedLabel: StyleRule = () => ({
    fontSize: pxToRem(30),
    marginTop: pxToRem(5),
    marginBottom: pxToRem(35),
    letterSpacing: 0,
});
